// project import
import {DashboardOutlined, IdcardOutlined ,QrcodeOutlined} from "@ant-design/icons";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [
        {
            id: "group-dashboard",
            title: "",
            type: "group",
            children: [
                {
                    id: "dashboard",
                    title: "Dashboard",
                    type: "item",
                    url: "/dashboard",
                    icon: DashboardOutlined,
                    breadcrumbs: false,
                },
                {
                    id: "business-card",
                    title: "Business Card",
                    type: "item",
                    url: "/canva",
                    icon: IdcardOutlined,
                    breadcrumbs: false,
                },
                {
                    id: "qr",
                    title: "QR Code",
                    type: "item",
                    url: "/qr",
                    icon: QrcodeOutlined,
                    breadcrumbs: false,
                },
            ],
        },
    ],
};

export default menuItems;
